import { render, staticRenderFns } from "./Sector.vue?vue&type=template&id=2db0eb7f&scoped=true"
import script from "./Sector.vue?vue&type=script&lang=js"
export * from "./Sector.vue?vue&type=script&lang=js"
import style0 from "./Sector.vue?vue&type=style&index=0&id=2db0eb7f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db0eb7f",
  null
  
)

export default component.exports